import { apiClient } from './client';
import type {
  SchoolNetwork,
  SchoolNetworkDetail,
  AvailableSchool,
  CreateSchoolNetworkData,
  UpdateSchoolNetworkData,
  SchoolNetworkResponse,
  NetworkMetrics,
} from '@/types/school-network';

export async function getSchoolNetworks(): Promise<SchoolNetwork[]> {
  const response = await apiClient.get<SchoolNetwork[]>('/api/school-networks');
  return response.data;
}

export async function getSchoolNetwork(id: number): Promise<SchoolNetworkDetail> {
  const response = await apiClient.get<SchoolNetworkDetail>(`/api/school-networks/${id}`);
  return response.data;
}

export async function createSchoolNetwork(
  data: CreateSchoolNetworkData
): Promise<SchoolNetworkResponse> {
  const response = await apiClient.post<SchoolNetworkResponse>('/api/school-networks', data);
  return response.data;
}

export async function updateSchoolNetwork(
  id: number,
  data: UpdateSchoolNetworkData
): Promise<SchoolNetworkResponse> {
  const response = await apiClient.put<SchoolNetworkResponse>(`/api/school-networks/${id}`, data);
  return response.data;
}

export async function deleteSchoolNetwork(id: number): Promise<{ message: string }> {
  const response = await apiClient.delete<{ message: string }>(`/api/school-networks/${id}`);
  return response.data;
}

export async function updateNetworkSchools(
  id: number,
  schoolIds: number[]
): Promise<{ message: string; schoolCount: number }> {
  const response = await apiClient.put<{ message: string; schoolCount: number }>(
    `/api/school-networks/${id}/schools`,
    { schoolIds }
  );
  return response.data;
}

export async function getAvailableSchools(networkId: number): Promise<AvailableSchool[]> {
  const response = await apiClient.get<AvailableSchool[]>(
    `/api/school-networks/${networkId}/available-schools`
  );
  return response.data;
}

export async function getAllAvailableSchools(): Promise<AvailableSchool[]> {
  const response = await apiClient.get<AvailableSchool[]>('/api/school-networks/available-schools');
  return response.data;
}

export async function getNetworkMetrics(id: number): Promise<NetworkMetrics> {
  const response = await apiClient.get<NetworkMetrics>(`/api/school-networks/${id}/metrics`);
  return response.data;
}
